import React from 'react'

export default function RitQuestion({ definition }) {
	const { open, close, phrase } = definition

	return (
		<div>
			<div className='text-Question'>
				{open}
				<span style={{ color: '#0962c7' }}>{phrase}</span> {close}
			</div>
		</div>
	)
}
